<template>
<div class="main mt15">
	<div class="banner">
		<img src="/static/images/haierProduct/banner.jpg" alt="" ref="info">
		<div class="banner-container">
			<div class="banner-container-title">平安企业团体雇主责任保险</div>
			<div class="banner-container-case">—  老板事业的护身符  —</div>
			<div class="banner-container-sub">
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>雇主意外</span>
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>职业病</span>
				<Icon type="md-checkmark-circle" color="#318af0"/> <span>误工津贴</span>
			</div>
			<div class="banner-container-btn">
				<a class="btn" @click="toBuy">立即购买</a>
			</div>
		</div>
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="产品介绍" name="info"></TabPane>
				<TabPane label="保障方案" name="case"></TabPane>
				<TabPane label="常见问题" name="question"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品介绍</div>
		<div class="detail-main">
			<div class="detail-main-title">什么是雇主责任险？</div>
			<div class="detail-main-text">
				是以被保险人即雇主（公司）的雇员在受雇期间从事业务时因遭受意外导致伤、残、死亡或患有与职业有关的职业性疾病而依法或根据雇佣合同 应由被保险人承担的经济赔偿责任为承保风险的一种责任保险 。雇主责任保险的保险责任，包括在责任事故中雇主对雇员依法应负的经济赔偿责任和有关法律费用等，导致这种赔偿的原因主要是各种意外的工伤事故和职业病。
			</div>
			<div class="detail-main-title">雇主责任险和意外险的区别是什么？</div>
			<div class="detail-main-text"  ref="case">
    			雇主责任险保障的人是雇主，而团体意外险保障的是雇员(员工)雇主意外险最大作用便是缓和雇主与雇员之间的纠纷，主要保障的是雇主的利益，比较注重风险的嫁接。而团体意外险是为了给员工以及员工的家属一份保障，注重的是对员工的保障和福利雇主责任险是不需要承担法律责任的，只需要将经济赔偿付予出事故的员工即可。团体意外险雇主是需要承担一定的法律责任的，雇员在得到赔偿之后还可以对雇主要求一定的经济赔偿。
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">保障方案</div>
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<thead>
						<tr>
							<th colspan="2" rowspan="2">方案</th>
							<th rowspan="2">死亡伤残</th>
							<th rowspan="2">医疗<br>(社保范围内用药)</th>
							<th rowspan="2">误工补贴</th>
							<th colspan="3">人员风险分类</th>
							<!-- <th rowspan="2">备注</th> -->
						</tr>
						<tr>
							<th>1-3类</th>
							<th>4类</th>
							<th>5类</th>
						</tr>
					</thead>
					<tbody>
						<tr class="hoverTr">
							<td rowspan="5" width="100" class="hoverDisabled">基础保障</td>
							<td>方案一</td>
							<td>10万</td>
							<td>2万</td>
							<td>100元/天</td>
							<td>72元/人/年</td>
							<td>125元/人/年</td>
							<td>194元/人/年</td>
							<!-- <td rowspan="5" width="100" class="hoverDisabled">企业总投保人员中五类人员占比不超过50%，若超过50%则五类人员对应保费上浮20%</td> -->
						</tr>
						<tr class="hoverTr">
							<td>方案二</td>
							<td>50万</td>
							<td>5万</td>
							<td>100元/天</td>
							<td>300元/人/年</td>
							<td>518元/人/年</td>
							<td>809元/人/年</td>
						</tr>
						<tr class="hoverTr">
							<td>方案三</td>
							<td>80万</td>
							<td>8万</td>
							<td>100元/天</td>
							<td>480元/人/年</td>
							<td>829元/人/年</td>
							<td>1294元/人/年</td>
						</tr>
						<tr class="hoverTr">
							<td>方案四</td>
							<td>100万</td>
							<td>12万</td>
							<td>100元/天</td>
							<td>560元/人/年</td>
							<td>967元/人/年</td>
							<td>1661元/人/年</td>
						</tr>
						<tr class="hoverTr">
							<td>方案五</td>
							<td>120万</td>
							<td>15万</td>
							<td>100元/天</td>
							<td>680元/人/年</td>
							<td>1175元/人/年</td>
							<td>2017元/人/年</td>
						</tr>
						<tr>
							<td rowspan="3">附加方案</td>
							<td>附加24小时意外</td>
							<td colspan="6">
								承保时间范围扩展至保险期间内全天24小时，而不论是否在工作期间。被保险人之雇员因意外事故而导致的死亡赔偿金、伤残赔偿金，保险人承担赔偿责任。<br>
								<b>基础方案价格*110%</b>
							</td>
							<!-- <td rowspan="3">选择附加该条款，基础方案价格上浮10%<br>
								选择附加该条款，基础方案价格上浮15%<br>
								选择附加该条款，基础方案价格上浮10%</td> -->
						</tr>
						<!-- <tr>
							<td>附加自费药赔偿</td>
							<td colspan="6">
								不再按照被保险人当地医保标准赔偿承保所有治疗费用中社保范围外合理的自费药部分费用。<br>
								<b>基础方案价格*115%</b>
							</td>
						</tr> -->
						<tr>
							<td>附加伤残赔偿比例调整</td>
							<td colspan="6">
								将伤残等级对应的赔偿比例进行调高，<b>基础方案价格上浮10%</b>，具体调整比例见
								<a @click="toSC">伤残赔偿比例表</a>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="productDetail-table mt20">
					<tbody>
						<tr>
							<td class="firstRow" width="200">适用范围</td>
							<td>
								雇员年龄<b class="importantText">16-65周岁</b>，1-5类工种，最低起保人数<b class="importantText">5人</b>
							</td>
						</tr>
						<tr>
							<td class="firstRow">死亡赔偿</td>
							<td>
								按保险单约定的每人死亡伤残赔偿限额计算死亡赔偿金额。
							</td>
						</tr>
						<tr>
							<td class="firstRow">伤残赔偿</td>
							<td>
								依据伤残鉴定机构出具的伤残程度鉴定书，按每人死亡伤残赔偿限额及 “伤残等级赔偿限额比例表”规定的比例计算伤残赔偿金额。
							</td>
						</tr>
						<tr>
							<td class="firstRow">医疗费用</td>
							<td>
								赔偿社保范围内的医疗费用，具体包括：<br>
								1．挂号费、治疗费、手术费、检查费、医药费、材料费、急救车费；<br>
								2．住院期间的床位费、取暖费、空调费。
							</td>
						</tr>
						<tr>
							<td class="firstRow">误工费用</td>
							<td>
								被保险人雇员暂时丧失工作能力持续五天以上的，经医院开具误工证明，最长赔付天数为180天。
							</td>
						</tr>
						<tr>
							<td class="firstRow">禁保行业</td>
							<td>
								本保单对道路清洁、渔业生产、远洋运输、采矿业 、木材加工、石材加工、修造船业、空调安装、两米以上高空作业等行业不承保，但若虽属于以上行业但工作性质为低风险的人员仍可承保（例如：木材加工业的工人不能承保，但管理人员可正常承保）
							</td>
						</tr>
						<tr>
							<td class="firstRow">保单时效</td>
							<td>
								企业可根据需求投保最少1个月最多12个月的保障方案，投保不足一年保费按照短期费率进行收取
							</td>
						</tr>
					</tbody>
				</table>
				<div class="detail-main-text align-left pt40" ref="SC"><b>伤残比例赔付表</b></div>
				<div class="center" ref="question">
					<table class="productDetail-table">
						<thead>
							<tr>
								<th width="200">伤残等级</th>
								<th>一级</th>
								<th>二级</th>
								<th>三级</th>
								<th>四级</th>
								<th>五级</th>
								<th>六级</th>
								<th>七级</th>
								<th>八级</th>
								<th>九级</th>
								<th>十级</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="firstRow">初始赔偿比例</td>
								<td class="pd0">100%</td>
								<td class="pd0">80%</td>
								<td class="pd0">70%</td>
								<td class="pd0">60%</td>
								<td class="pd0">40%</td>
								<td class="pd0">30%</td>
								<td class="pd0">20%</td>
								<td class="pd0">15%</td>
								<td class="pd0">7%</td>
								<td class="pd0">5%</td>
							</tr>
							<tr>
								<td class="firstRow">附加伤残赔偿比例调整条款后的赔偿比例</td>
								<td class="pd0">100%</td>
								<td class="pd0">90%</td>
								<td class="pd0">80%</td>
								<td class="pd0">70%</td>
								<td class="pd0">60%</td>
								<td class="pd0">50%</td>
								<td class="pd0">40%</td>
								<td class="pd0">30%</td>
								<td class="pd0">20%</td>
								<td class="pd0">10%</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">常见问题</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p><b>1.公司有人员变动，应该怎么办？</b></p>
				<p>
					雇主责任险是实名制的，投保时需要输入每位员工的身份证号码。如果您公司人员变动，可在保单详情页点击<b>参加人员编辑</b>进行变动，新增人员按照短期费率进行收费，人员替换免费。
					短期费率表：
				</p>
				<div class="center">
					<table class="productDetail-table">
						<thead>
							<tr>
								<th>保险期间已经过月数（个月）</th>
								<th>1个月</th>
								<th>2个月</th>
								<th>3个月</th>
								<th>4个月</th>
								<th>5个月</th>
								<th>6个月</th>
								<th>7个月</th>
								<th>8个月</th>
								<th>9个月</th>
								<th>10个月</th>
								<th>11个月</th>
								<th>12个月</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="firstRow">年费率的比例（％）</td>
								<td class="pd0">10%</td>
								<td class="pd0">20%</td>
								<td class="pd0">30%</td>
								<td class="pd0">40%</td>
								<td class="pd0">50%</td>
								<td class="pd0">60%</td>
								<td class="pd0">70%</td>
								<td class="pd0">80%</td>
								<td class="pd0">85%</td>
								<td class="pd0">90%</td>
								<td class="pd0">95%</td>
								<td class="pd0">100%</td>
							</tr>
						</tbody>
					</table>
				</div>
				<p><b>2.投保后怎么拿到保单呢？</b></p>
				<p>线上投保，我们将在您付款后的三天内为您生成电子保单，点击右上角用户中心--我的保单，就可以看到您的电子保单了。如您需要纸质保单，可自行下载打印。电子保单具有和纸质保单同样的法律效力。</p>
				<p><b>3.如何确定员工的风险等级？</b></p>
				<p>可自行查看风险职业类别表，查看员工对应的工种所对应的风险分类。
					<a href="/static/pdf/haierProduct/职业类别表.pdf" target="_blank">点击查看职业类别表</a>
				</p>
				<p><b>4.同一公司不同工种能否选择不同方案？</b></p>
				<p>针对于不同工种可选择不同保障额度的方案，最大限度节约公司成本，同一法人企业累计最低投保人数为5人。</p>
			</div>
		</div>
	</div>
	<div class="detail" ref="claim">
		<div class="detail-title">理赔流程</div>
		<Steps class="mt30">
			<Step 
				title="拨打报案电话" 
				status="process"
				content="请立即拨打报案电话95511或0532-88931681进行报案，详细说明出险情况。"
			></Step>
			<Step 
				title="提交索赔材料" 
				status="process"
				content="书面告知您的索赔须知内容提交索赔所需的全部材料，我们将协助准备相应材料"
			></Step>
			<Step 
				title="领取赔款" 
				status="process"
				content="保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款"
			></Step>
		</Steps>
		<br>
		<br>
	</div>
	<TrackNotice companyName="平安企业团体雇主责任保险" />
</div>
</template>
<script>
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			rules:{
				code:[{required:true,message:'请输入88码',trigger:'blur'}]
			},
			tabName:'info',
			fixed:false,
			renewId:this.$route.query.renewId||'' //续保，上一保单id
		}
	},
	mounted() {
		//2023.8.7增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll);
        	this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods:{
		// 立即购买
		toBuy() {
			// 回溯功能
			this.stopRecord({
				is_new: true
			}).then(()=>{
				let url='/haierProduct.html#/company-group-employer/fillin';
				if(this.renewId)url+=`/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
				else url+=`?productCode=QYTTGZZRXPCNEW`
				location.href=url
			})
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView()
		},
		// 定位到伤残费率表位置
		toSC() {
			this.$refs['SC'].scrollIntoView()
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		margin-bottom: 30px;
	}
	.pb50{
		padding-bottom: 50px;
	}
	.pt40{
		padding-top: 40px;
	}
	.banner-container{
		position: absolute;
		font-size: 14px;
		text-align:center;
		width: 510px;
		top:80px;
		left:0;
		right:0;
		color:#fff;
		.notes{
			margin-top: 10px;
		}
		&-title{
			font-size: 32px;
			color: #333;
		}
		&-case{
			font-size: 24px;
			line-height: 2;
			color: #318af0;
		}
		&-sub{
			font-size: 14px;
			color: #555;
			margin-top: 30px;
			span{
				margin-right: 5px;
			}
		}
		&-desc{
			font-size: 18px;
		}
		&-input{
			width:300px;
			margin:20px auto 0;
		}
		&-btn{
			margin-top: 30px;
			a{
				width:240px;
			}
		}
	}
	.detail-title{
		font-size: 30px;
	}
	.detail-main{
		.center{
			font-size: 0;
		}
		&-title,&-text{
			padding-left: 20px;
		}
		&-title{
			font-size: 18px;
		}
		&-text{
			line-height:2;
		}
	}
	.tabs{
		display: block;
		height: 46px;
		&-container{
			padding: 10px 10px 0;
			background: #fff;
			height: 46px;
			overflow: hidden;
			position: relative;
			&-form{
				position: absolute;
				right: 10px;
				bottom: 5px;
				button{
					display: inline-block;
				}
			}
		}
		.fixed{
			position: fixed;
			top: 100px;
			left: 0;
			right: 0;
			margin: auto;
			width: 1200px;
		}
	}

	.productDetail-table.sm{
		font-size: 13px;
		.fs16{
			font-size: 16px;
		}
		td{
			padding:8px;
		}
	}
	.hoverTr:hover{
		color: #fff;
		td{
			background: #77adf5;
		}
		.hoverDisabled{
			background: #fafafa;
			color: #333;
		}
	}
	.importantText{
		color: #77adf5;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/Index.vue